<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00043.installation.regulation' | translate"
      [description]="'P00043.installation.regulation.description' | translate"
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P00043.installation.regulation.mode' | translate"
      [titleListe]="'P00043.installation.regulation.mode.value' | translate"
      [value]="actionStack!.getValue('paPModeRegulation')"
      [liste]="P00043ModeRegulation"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PAC_Parametrage2,
          'paPModeRegulation',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    <app-label-configuration
      [titleListe]="'P00043.installation.regulation.consigne.value' | translate"
      [value]="actionStack!.getValue('paPConsigneTemperature')"
      [liste]="P00043ConsigneTemperatureEnum()"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PAC_Parametrage,
          'paPConsigneTemperature',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    <app-label-description
      [description]="
        'P0003600.installation.preventiongel.typeFonctionHorsGel.description'
          | translate
      "
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
